var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignalLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.424,
    height: 21.582,
    viewBox: "0 0 19.424 21.582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "signal-low",
    transform: "translate(-39.313 -21.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1166",
    "data-name": "Group 1166",
    transform: "translate(39.313 21.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_bluetooth_connected_24px",
    d: "M7.316,12.791,5.158,10.633,3,12.791l2.158,2.158ZM18.874,8.162,12.712,2H11.633v8.19L6.68,5.237,5.158,6.759l6.032,6.032L5.158,18.823,6.68,20.345l4.953-4.953v8.19h1.079l6.162-6.162-4.64-4.629ZM13.791,6.133,15.82,8.162,13.791,10.19ZM15.82,17.42l-2.029,2.029V15.392L15.82,17.42Zm4.446-6.788-2.158,2.158,2.158,2.158,2.158-2.158Z",
    transform: "translate(-3 -2)",
    fill: "#d99595"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_107",
    "data-name": "Line 107",
    x2: 15,
    y2: 15,
    transform: "translate(42.083 25.326)",
    fill: "none",
    stroke: "red",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalLow);
export default __webpack_public_path__ + "static/media/signal-low.b05c379d8ad05a13ef86d2422d95f91a.svg";
export { ForwardRef as ReactComponent };